import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { firstItem } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { UnitType } from '../state/types'

export const useUnitTypeLoaders = () => {
    const { getList, find, findByParams } = useStateHooks()

    const loaders = useLoaders(false)

    return () => {
        const findAllUnitTypes = () => getList(TableName.UNIT_TYPES) as UnitType[]

        const findUnitType = (id?: string) => find(TableName.UNIT_TYPES, id) as O<UnitType>

        const findUnitTypeByName = (name: string) => firstItem(findByParams(TableName.UNIT_TYPES, { name })) as O<UnitType>

        const loadAllUnitTypes = (dbRequest = false) => {
            const { loadAll } = loaders()
            return loadAll(TableName.UNIT_TYPES, dbRequest) as Promise<UnitType[]>
        }

        return {
            findAllUnitTypes,
            findUnitType,
            findUnitTypeByName,
            loadAllUnitTypes
        }
    }
}
